import { AZURE_URL } from "../constants/env-constants";

export const getAllStaff = async () => {
  try {
    const response = await AZURE_URL.get("/staff/get/all");
    return [response.data, null];
  } catch (error: any) {
    return [null, "Server error: " + error.response.data];
  }
};

// export const getAllTeams = async () => {
//   try {
//     const response = await AZURE_URL.get("/staff/team/get/all");
//     if (response.status === 200) {
//       return [response.data, null];
//     } else {
//       return [null, response];
//     }
//   } catch (error: any) {
//     return error.response;
//   }
// };

export const deleteStaff = async (id: string) => {
  try {
    const response = await AZURE_URL.delete(`/staff/delete?publicId=${id}`);
    return [response, null];
  } catch (error: any) {
    console.log(error);
    return [null, "Server Error: " + error.response.data];
  }
};

export const updateStaff = async (data: any) => {
  try {
    const response = await AZURE_URL.put("/staff/update", data);
    return [response.data, null];
  } catch (error: any) {
    console.log(error);
    return [null, "Server Error: " + error.response.data];
  }
};

export const getStaffDetailsById = async (id: string) => {
  try {
    const response = await AZURE_URL.get(`/staff/get?publicId=${id}`);
    return [response.data, null];
  } catch (error: any) {
    return [null, "Server error: " + error.response.data];
  }
};
